import { EllipsisVertical } from 'lucide-react'
import { ButtonIcon, Col, DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger, FormGroup, Label, Select } from 'twyne-new.ui'

export default function CustomFieldSelect({ size = '6', value, options, disabled, onChange, onAdd, onEdit, canEdit }) {
  return <Col size={size}>
    <FormGroup>
      <Label>Custom Field</Label>
      <div className='flex items-center gap-2'>
        <div className='grow'>
          <Select name='type' value={value || ''} options={options} onChange={onChange} disabled={disabled} />
        </div>
        <DropdownMenu optionsLabel='Custom field'>
          <DropdownMenuTrigger>
            <ButtonIcon content='Custom field options' disabled={disabled}>
              <EllipsisVertical size={16} />
            </ButtonIcon>
          </DropdownMenuTrigger>
          <DropdownMenuContent>
            <DropdownMenuItem onClick={onAdd}>
              Add
            </DropdownMenuItem>
            {onEdit ? <DropdownMenuItem disabled={!canEdit} onClick={onEdit}>
              Edit
            </DropdownMenuItem> : null}
          </DropdownMenuContent>
        </DropdownMenu>
      </div>
    </FormGroup>
  </Col>
}
